import { getLocale } from "../runtime";

const da_notfoundsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vi kan ikke finde den side, du leder efter.`
};

const en_notfoundsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `We can't seem to find the page you're looking for.`
};

const es_notfoundsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `No podemos encontrar la página que estás buscando.`
};

const fi_notfoundsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Emme löydä etsimääsi sivua.`
};

const nb_notfoundsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vi kan ikke finne siden du leter etter.`
};

const sv_notfoundsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vi kan inte hitta sidan du letar efter.`
};

const notfoundsubtitle = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_notfoundsubtitle(inputs)
	if (locale === "en") return en_notfoundsubtitle(inputs)
	if (locale === "es") return es_notfoundsubtitle(inputs)
	if (locale === "fi") return fi_notfoundsubtitle(inputs)
	if (locale === "nb") return nb_notfoundsubtitle(inputs)
	if (locale === "sv") return sv_notfoundsubtitle(inputs)
	return "notFoundSubtitle";
};

export { notfoundsubtitle as "notFoundSubtitle" };